import type { SVGProps } from 'react';
const SvgCases = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cases_svg__a)">
      <path
        fill="currentColor"
        d="M18 6V4l-2-2h-5L9 4v2H5v11s1 2 2 2h13s2-.98 2-2V6h-4ZM4 9H2v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H4V9Zm7-4c0-.55.53-1 1-1h3c.46 0 1 .54 1 1v1h-5V5ZM5 6h17v11c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6Z"
      />
    </g>
    <defs>
      <clipPath id="cases_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCases;
